import { render, staticRenderFns } from "./request_payment.vue?vue&type=template&id=66b75054&"
import script from "./request_payment.vue?vue&type=script&lang=js&"
export * from "./request_payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports